"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baselineAppStyles = void 0;

var _index = require("./index");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // .......... BASELINE PROJECT STYLES .......... //
// media queries
// http://giona.net/tools/css3-mediaquery-generator/


var baselineAppStyles = {
  '@import': ['url(https://use.fontawesome.com/releases/v5.5.0/css/all.css)', // used for icons
  'url(https://fonts.googleapis.com/css?family=Work+Sans:400,500,600,700&display=swap)'],
  '@global': _objectSpread({
    'html, body, #root': {
      // overflow: 'hidden',
      scrollBehavior: 'smooth',
      // animate scrolling for when we scroll to top based on history
      height: '100%' // needed for full size app (also needed to add #root div here)

    },
    html: {
      fontSize: _index.fontSizeBaseline + 'px'
    },
    '*, *:before, *:after': {
      boxSizing: 'border-box',
      margin: '0',
      padding: '0'
    },
    body: {
      backgroundColor: 'transparent',
      color: _index.theme.color.supporting.dark.swatch,
      fontFamily: _index.theme.typography.font,
      fontWeight: '500',
      fontSize: '1rem',
      fontSmoothing: 'antialiased' // subpixel-antialiased // ***** needed to cleanup font clarity on webkit browsers ***** //
      // https://forum.webflow.com/t/a-fix-for-when-your-elements-move-up-and-or-blur-during-animations-interactions-on-chrome/11629

    },
    button: {
      fontFamily: _index.theme.typography.font
    },
    a: {
      color: _index.theme.color.primary.medium.swatch,
      textDecoration: 'none',
      transition: 'color .2s linear 0s'
    },
    'a:hover': {
      filter: 'brightness(85%)',
      textDecoration: 'none'
    },
    '.accessibility': {
      display: 'none'
    },
    '.clump': {
      whiteSpace: 'nowrap'
    },
    '& #app': {
      height: '100%'
    }
  }, _index.fadeIn, {}, _index.fadeOut, {}, _index.slideIn, {}, _index.slideOut, {}, _index.flip, {}, _index.flipIn, {}, _index.flipOut, {}, _index.shake, {}, _index.headShake, {}, _index.wobble, {}, _index.tada, {}, _index.swing, {}, _index.rubberBand, {}, _index.pulse, {}, _index.jello, {}, _index.hinge, {}, _index.flash, {}, _index.lightSpeedIn, {}, _index.lightSpeedOut, {}, _index.rollIn, {}, _index.rollOut, {}, _index.rotateIn, {}, _index.rotateOut)
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.baselineAppStyles = baselineAppStyles;